import { graphql } from 'gql';

export const catalogRemoveWorkTypes = graphql(`
    mutation catalogRemoveWorkTypes($catalogWorkTypeIds: [Int!]!) {
        catalogRemoveWorkTypes(catalogWorkTypeIds: $catalogWorkTypeIds) {
            actionRequired
            buttonText
            code
            hideValidation
            hasValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const catalogCreateWorkType = graphql(`
    mutation catalogCreateWorkType($input: CatalogWorkTypeCreateInput!) {
        catalogCreateWorkType(input: $input) {
            actionRequired
            buttonText
            code
            data {
                code
                hasPrice
                id
                name
                uniqueId
                unit
                updatedAt
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const catalogUpdateWorkTypeGql = graphql(`
    mutation catalogUpdateWorkType($input: CatalogWorkTypeUpdateInput!) {
        catalogUpdateWorkType(input: $input) {
            actionRequired
            buttonText
            code
            data {
                id
                code
                hasPrice
                name
                uniqueId
                unit
                updatedAt
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const CatalogWorkTypeCodeFilter = graphql(`
    query catalogWorkTypeCodeFilter($where: FilterValueOfStringFilterInput) {
        catalogWorkTypeCodeFilter(where: $where, take: 1000) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const CatalogWorkTypeNameFilter = graphql(`
    query catalogWorkTypeNameFilter($where: FilterValueOfStringFilterInput) {
        catalogWorkTypeNameFilter(where: $where, take: 1000) {
            totalCount
            items {
                value
            }
        }
    }
`);

export const CatalogWorkTypeItemsGql = graphql(`
    query catalogWorkTypeItems(
        $order: [CatalogWorkTypeDataSortInput!]
        $skip: Int
        $take: Int
        $where: CatalogWorkTypeDataFilterInput
        $catalogUniqueId: String!
    ) {
        catalogWorkTypeItems(
            where: $where
            take: $take
            skip: $skip
            order: $order
            catalogUniqueId: $catalogUniqueId
        ) {
            items {
                code
                hasPrice
                id
                name
                uniqueId
                unit
                updatedAt
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogWorkTypesUpdatedDateGql = graphql(`
    query catalogWorkTypesUpdatedDate($catalogId: Long!) {
        catalogWorkTypesUpdatedDate(catalogId: $catalogId) {
            actionRequired
            buttonText
            code
            data {
                catalogId
                updatedAt
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const catalogIsUniqueWorkTypeCodeGql = graphql(`
    query catalogIsUniqueWorkTypeCode($catalogWorkTypeId: Int, $code: String!) {
        catalogIsUniqueWorkTypeCode(catalogWorkTypeId: $catalogWorkTypeId, code: $code) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);
